import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { Dashboard } from '../components/Dashboard';
import { db } from '../firebase';

export const DashboardPage = () => {
  const navigate = useNavigate();
  const { user, examResults } = useApp();

  const handleToggleBookmark = async (questionId) => {
    if (!user) return;
    const bookmarkRef = db.ref(`users/${user.uid}/bookmarks/questions/${questionId}`);
    const isBookmarked = !!user.bookmarks?.questions?.[questionId];
    try {
      if (isBookmarked) {
        await bookmarkRef.remove();
      } else {
        await bookmarkRef.set({ question_id: questionId, created_at: new Date().toISOString() });
      }
    } catch (error) {
      console.error("Failed to update bookmarks:", error);
    }
  };

  if (!user) {
    navigate('/signin');
    return null;
  }

  return (
    <div className="bg-white text-black dark:bg-gray-800 dark:text-white">
      <Dashboard 
        user={user} 
        examResults={examResults} 
        onToggleBookmark={handleToggleBookmark}
      />
    </div>
  );
};